module.exports = __webpack_public_path__ + "img/38400.487a9e27.jpg";